import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-81f55108"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stock-search" }
const _hoisted_2 = { class: "flex-end" }

import { t } from '@/plugins/i18n'
import { ref, toRaw, watch, computed } from 'vue'
import { cloneDeep } from 'lodash'
import { clearForm, setDefaultForm } from '@/util/common'
import dblclick from '@/components/BatchSearch/index'


export default /*#__PURE__*/_defineComponent({
  props: ['form'],
  emits: ['update:form'],
  setup(__props, { emit: emits }) {

const props = __props



const defaultForm = {
  platformOrderNo: '',
  productSku: '',
  customerProductMsku: ''
}

const getForm = (form: any) => setDefaultForm(cloneDeep(toRaw(form)), defaultForm)
const _form = ref(getForm(props.form))

watch(() => props.form, (newValue) => {
  _form.value = getForm(newValue)
})
const submit = () => {
  emits('update:form', cloneDeep(toRaw(_form.value)))
}

const resetForm = () => {
  clearForm(_form.value)
  emits('update:form', cloneDeep(toRaw(_form.value)))
}


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      inline: true,
      model: _form.value,
      class: "flex"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: _unref(t)('THE CKB订单编号'),
          style: {"width":"263px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.platformOrderNo,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_form.value.platformOrderNo) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('平台商品SKU'),
          style: {"width":"263px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.productSku,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_form.value.productSku) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, {
          label: _unref(t)('客户商品sku'),
          style: {"margin-right":"0 !important","width":"263px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _form.value.customerProductMsku,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_form.value.customerProductMsku) = $event))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_form_item, { style: {"padding":"30px 0 0 20px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: submit,
              class: "btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('搜索')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_button, {
              onClick: resetForm,
              class: "btn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(t)('清空')), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})